import X from "../../../@babel/runtime/helpers/esm/objectSpread22.mjs";
function Y() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], r = arguments.length > 2 ? arguments[2] : void 0;
  return r ? t[0] === e[0] : t[0] === e[0] && t[1] === e[1];
}
function q(t, e, r, o) {
  for (var n = r.points, d = Object.keys(t), i = 0; i < d.length; i += 1) {
    var a, l = d[i];
    if (Y((a = t[l]) === null || a === void 0 ? void 0 : a.points, n, o))
      return "".concat(e, "-placement-").concat(l);
  }
  return "";
}
function D(t, e, r, o) {
  return e || (r ? {
    motionName: "".concat(t, "-").concat(r)
  } : o ? {
    motionName: o
  } : null);
}
function y(t) {
  return t.ownerDocument.defaultView;
}
function F(t) {
  for (var e = [], r = t == null ? void 0 : t.parentElement, o = ["hidden", "scroll", "clip", "auto"]; r; ) {
    var n = y(r).getComputedStyle(r), d = n.overflowX, i = n.overflowY, a = n.overflow;
    [d, i, a].some(function(l) {
      return o.includes(l);
    }) && e.push(r), r = r.parentElement;
  }
  return e;
}
function s(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  return Number.isNaN(t) ? e : t;
}
function h(t) {
  return s(parseFloat(t), 0);
}
function P(t, e) {
  var r = X({}, t);
  return (e || []).forEach(function(o) {
    if (!(o instanceof HTMLBodyElement)) {
      var n = y(o).getComputedStyle(o), d = n.overflow, i = n.overflowClipMargin, a = n.borderTopWidth, l = n.borderBottomWidth, S = n.borderLeftWidth, T = n.borderRightWidth, u = o.getBoundingClientRect(), m = o.offsetHeight, x = o.clientHeight, p = o.offsetWidth, C = o.clientWidth, W = h(a), b = h(l), w = h(S), M = h(T), v = s(Math.round(u.width / p * 1e3) / 1e3), f = s(Math.round(u.height / m * 1e3) / 1e3), E = (p - C - w - M) * v, A = (m - x - W - b) * f, B = W * f, V = b * f, N = w * v, O = M * v, c = 0, g = 0;
      if (d === "clip") {
        var H = h(i);
        c = H * v, g = H * f;
      }
      var L = u.x + N - c, R = u.y + B - g, j = L + u.width + 2 * c - N - O - E, I = R + u.height + 2 * g - B - V - A;
      r.left = Math.max(r.left, L), r.top = Math.max(r.top, R), r.right = Math.min(r.right, j), r.bottom = Math.min(r.bottom, I);
    }
  }), r;
}
export {
  F as collectScroller,
  q as getAlignPopupClassName,
  D as getMotion,
  P as getVisibleArea,
  y as getWin,
  s as toNum
};
//# sourceMappingURL=util.mjs.map
